;(function(global, $, undefined) {
    /**
     * View model constructor for Attachment Picker
     */
    app.registerConstructor("AttachmentPickerCtrl", function(opts) {
        const self = this;
        this.expended = ko.observable(opts.expended);
        this.hasApplForm = ko.observable(opts.hasApplForm);
        this.fileLimit = opts.fileLimit;
        this.attachmentCount = ko.observable(opts.attachmentCount);
        this.uploaderVM = null;

        this.toggleLinkLabel = ko.pureComputed(function() {
	        const expended = this.expended();
	        return expended ? opts.Messages.Hide : opts.Messages.AddMore
        }, this);

	    this.toggleExpended = () => {
	    	self.expended(!self.expended())
        };

        this.hasAttachment = ko.pureComputed(function() {
            return this.attachmentCount() > 0
        }, this);

        this.tooManyAttachment = ko.pureComputed(function() {
            return this.attachmentCount() >= this.fileLimit
        }, this);

        this.updateAttachmentState = function(data) {
            if (data) {
                if (data.count !== undefined) this.attachmentCount(data.count);
                this.hasApplForm(data.hasApplForm)
            }
        };
        this.attachmentCount.subscribe(function(newValue) {
            if (this.uploaderVM) {
                this.uploaderVM.setUploaderDocumentCount(newValue)
            }
        }, this);
    });

    /**
     * View model constructor for Local File Uploader
     */
    app.registerConstructor("LocalFileUploaderCtrl", function(opts) {
        const self = this;
        this.isShowListHeader = ko.observable(true);
        this.selector = opts.selector || 'none';
        this.autoSelectStrategy = opts.autoSelectStrategy || 'none';
        this.selectedDocumentNames = ko.observable("");

        function initDoc(doc) {
            if (!doc.docType) doc.docType = "";
            if (!doc.notes) doc.notes = "";
            if (!doc.userName) doc.userName = "";
            if (!doc.createdDate) doc.createdDate = "";

            doc.editing=!doc.docType;
            doc.newNotes = doc.notes;
            doc.newDocType = doc.docType;
            doc.selected = false;
        }

        ko.utils.arrayForEach(opts.documents, function (doc) {
            initDoc(doc)
        });

        this.onSelectItem = function(doc) {
            if (self.selector === 'radio') {
                _.each(_.filter(self.documents(), (d) => d !== doc), (d) => d.selected(false));
            }
            self.updateSelectedDocumentNames();
            return true;
        };

        this.updateSelectedDocumentNames = function() {
            self.selectedDocumentNames(_(self.documents()).filter((d) => d.selected()).map((d) => d.name()).join(","));
        };

        this.getSelectedDocumentIds = function() {
            return _(self.documents()).filter((d) => d.selected()).map((d) => d.id());
        };



        /**
         * update uploadedFileCount for the primefaces uploader
         */
        this.setUploaderDocumentCount = function(count) {
            var w = PF(opts.uploaderWigetVar);
            if (w) {
                PF(opts.uploaderWigetVar).uploadedFileCount = count
            } else {
                app.console.error("PF('" + opts.uploaderWigetVar + "') is undefined. ")
            }
        };

        this.__init__ = function() {
            $("div#uploadedDocumentList").find("tr:not(:visible)").show();
            app.vm.Global.runWhen(
                function() {
                    self.setUploaderDocumentCount(self.documents().length);
                },
                function() {
                    return PF(opts.uploaderWigetVar);
                },
                40
            )
        };

        /**
         * Uploaded document list
         */
        /* ko.mapping.fromJS turns the plain JS array into an arrayObservable and also
         * turns the properties on each element into observables*/
        this.documents = ko.mapping.fromJS(opts.documents);

        /**
         * Options of document type dropdown
         */
        this.docTypes = opts.docTypes;

        /**
         * Document properties for the next upload
         */
        this.newUploadProperties = {
            docType : ko.observable(""),
            notes: ko.observable("")
        };

        /**
         * Maximum numbers of file can be uploaded
         */
        this.fileLimit = opts.fileLimit;

        /**
         * Whether the number of uploaded file reaches the fileLimit
         */
        this.isReachLimit = ko.pureComputed(function() {
            return this.documents().length >= this.fileLimit
        }, this);

        /**
         * Whether a document item is valid to be saved
         */
        this.canSave = function(doc) {
            return (doc.newDocType() !== doc.docType() || doc.newNotes() !== doc.notes()) && doc.newDocType() !== ''
        };

        /**
         *  Controls whether to show additional properties. e.g. Notes and File type.
         * @type {boolean}
         */
        this.showFilePropertyFields = opts.showFilePropertyFields;

        /**
         * To remove a document item. This function invokes the p:remoteCommand stub to fire an ajax submission.
         */
        this.remove = function(doc) {
            if (confirm && !confirm(doc.name() + ' is going to be deleted. Are you sure?')) {
                return
            }
            if (doc.selected()) {
                self.updateSelectedDocumentNames();
            }
            remoteRemoveDocument([{name:"docId", value:doc.id()}, {name:"hash", value:doc.hash()}])
        };

        /**
         * Callback when the removal ajax submission completed. This function updates the document view model based on the result.
         */
        this.onRemoveComplete = function(args) {
            if (args && args.success) {
                var id = args.docId;
                var docItem = self.findDocById(id);
                if (docItem) {
                    self.documents.remove(docItem);
                    self.setUploaderDocumentCount(self.documents().length);
                    if (docItem.selected()) {
                        self.selectedDocumentNames("");
                    }
                    self.enableUploader();
                }
            }
        };

        this.enableUploader = function() {
        	const uploader = PF(opts.uploaderWigetVar);
	        uploader.enableButton(uploader.chooseButton);
	        uploader.chooseButton.find('input[type="file"]').removeAttr('disabled');
        };

	    this.disableUploader = function() {
		    const uploader = PF(opts.uploaderWigetVar);
		    uploader.disableButton(uploader.chooseButton);
		    uploader.chooseButton.find('input[type="file"]').attr('disabled', 'disabled');
	    };

        /**
         * View document content in a new window
         */
        this.open = function(doc) {
            window.open(doc.url(),'documentsPopup','resizable=yes,scrollbars=yes,toolbar=no ');
        };

        /**
         * Highlight the last modified item
         */
        this.highlightDoc = function(id, color, delay) {
            if (!color) color = '#dff0d8';
            if (!delay) delay = 500;
            $("tr#doc-"+id).css({'background-color': color});
            setTimeout(function() {$("tr#doc-"+id).animate({'background-color': '#fff'}, 800, function() {
                $("tr#doc-"+id).css("background-color", "")
            })}, delay)
        };

        function autoSelect(newDoc) {
            let shouldSelect = false;
            if (self.selector !== "none") {
                if (self.autoSelectStrategy === 'first') {
                    if (self.documents().length === 1) {
                        shouldSelect = true;
                    }
                } else if (self.autoSelectStrategy === 'notEmpty') {
                    if (self.getSelectedDocumentIds().length === 0) {
                        shouldSelect = true;
                    }
                } else if (self.autoSelectStrategy === 'last') {
                    shouldSelect = true;
                }
            }
            if (shouldSelect) {
                newDoc.selected(true);
                self.onSelectItem(newDoc);
            }
        }

        /**
         * Callback when an upload submission is completed. It updates the view model based on ajax result.
         */
        this.onUploadComplete = function(args) {
            if (args && args.success) {
	            const doc = args.doc;
	            initDoc(doc);
                //ko.mapping.fromJS turns the properties on doc into observables
                const newDoc = ko.mapping.fromJS(doc);
                self.documents.push(newDoc);
                self.newUploadProperties.notes("");
                self.highlightDoc(doc.id);
                autoSelect(newDoc);
            }

            //always update document count
            self.setUploaderDocumentCount(self.documents().length)
        };

        /**
         * Utility function to find a document item by its id
         */
        this.findDocById = function(id) {
            return ko.utils.arrayFirst(self.documents(), function(item) {
                return item.id() == id; //Use == on purpose
            })
        };

        /**
         * Exit edit mode without saving
         */
        this.cancelEdit = function(doc) {
            if (!doc.editing()) return;
            if (doc.docType() === "") {
                alert("Please specify a document type.");
                return
            }
            if (self.canSave(doc)) {
                if (confirm && !confirm('Your change will be lost. Are you sure?')) {
                    return
                }
            }
            self.exitEdit(doc);
            self.highlightDoc(doc.id(), null, 200)
        };

        /**
         * Save user inputed file properties
         */
        this.saveEdit = function(doc) {
            if (doc.newDocType() === "") {
                alert("Please specify a document type.");
                return
            }
            if (self.canSave(doc)) {
                remoteSaveDocumentInfo([
                    {name: 'docId', value: doc.id()},
                    {name: 'hash', value: doc.hash()},
                    {name: 'docType', value: doc.newDocType()},
                    {name: 'notes', value: doc.newNotes()}
                ])
            }
        };

        /**
         * Callback when file properties has been saved. It updates the view model based on ajax result.
         */
        this.onSaveInfoComplete = function(args) {
            if (args) {
                var id = args.docId;
                var doc = self.findDocById(id);
                if (!doc) return;
                if (args.success) {
                    doc.docType(doc.newDocType());
                    doc.notes(doc.newNotes());
                    self.exitEdit(doc);
                    self.highlightDoc(id)
                } else {
                    self.highlightDoc(id, '#FFBABA', 200)
                }
            }
        };

        /**
         * Enter edit mode for a document item
         */
        this.enterEdit = function(doc) {
            if (doc.editing()) return;
            doc.newDocType(doc.docType());
            doc.newNotes(doc.notes());
            let $docNote = $('textarea#docNotes-' + doc.id());
            $docNote.height($('div#docNotesSpan-' + doc.id()).height());
            doc.editing(true);
            if ($docNote.height() < 100) {
                $docNote.stop().animate({height: 100}, 200)
            }
        };

        /**
         * Exit edit mode for a document item
         */
        this.exitEdit = function(doc) {
            if (!doc.editing()) return;
            var noteSpan = $('div#docNotesSpan-' + doc.id());
            var textarea = $('textarea#docNotes-' + doc.id());
            if (noteSpan.height() > 0 && textarea.height() > noteSpan.height()) {
                textarea.stop().animate({height: noteSpan.height()}, 200, function() {
                    doc.editing(false)
                })
            } else {
                doc.editing(false)
            }
        };

        // Animation callbacks for the document list
        this.showItemAnimation = function(elem) {
            if (elem.nodeType === 1) {
                var el = $(elem);
                el.css({'background-color': '#d4edda'});
                setTimeout(function() {el.animate({'background-color': '#fff'}, 800, function() {
                    el.css("background-color", "")
                })}, 500)
            }
        };

        this.removeItemAnimation = function(elem) {
            if (elem.nodeType === 1) {
                $(elem).fadeOut(function() {
                    $(elem).remove();
                })
            }
        };

        //Attach drag-and-drop indication event
        (function() {
            $(document)
                .on('dragover dragenter',function() {
                    $("div.raspDragAndDropUploader div.ui-fileupload.ui-widget").addClass('is-dragover');
                })
                .on('dragleave dragend drop',function() {
                    $("div.raspDragAndDropUploader div.ui-fileupload.ui-widget").removeClass('is-dragover');
                });
        })();
    });

})(window, jQuery);
